// extracted by mini-css-extract-plugin
export default {"brass-window":"Window_brass-window__1cl-U"};